<div class="dev-tools-panel" #panel (mousedown)="startDrag($event)">
  <div class="dev-tools-panel-header">
    <span>{{ 'dev-tools.title' | translate }}</span>
    <div class="header-actions" (mousedown)="$event.stopPropagation()">
      <button mat-icon-button class="header-btn header-btn--reset" (click)="resetPanel()" [title]="'Reset position & size'" aria-label="Reset position & size">
        <mat-icon>center_focus_strong</mat-icon>
      </button>
      <button mat-icon-button class="header-btn" (click)="closed.emit()" [attr.aria-label]="'common.close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="dev-tools-panel-content" (mousedown)="$event.stopPropagation()">
    <div class="toggle-row">
      <button class="face-toggle" [class.active]="mockVisible$ | async" (click)="toggleMock()" [title]="'Toggle mock autofill'">
        <span class="face-track">
          <span class="face-thumb">
            <span class="face-eyes">
              <span class="eye"></span>
              <span class="eye"></span>
            </span>
            <span class="face-mouth"></span>
          </span>
        </span>
        <span class="face-label">{{ 'dev-tools.mock-toggle-label' | translate }}</span>
      </button>
      <span class="shortcut-hint"><kbd>Ctrl</kbd><span class="shortcut-plus">+</span><kbd>M</kbd>&nbsp;{{ 'dev-tools.mock-shortcut-hint' | translate }}</span>
    </div>

    <div class="toggle-row">
      <button class="face-toggle network" [class.active]="networkVisible$ | async" (click)="toggleNetwork()" title="Toggle Network panel">
        <span class="face-track">
          <span class="face-thumb">
            <mat-icon class="thumb-icon">wifi</mat-icon>
          </span>
        </span>
        <span class="face-label">Network</span>
      </button>
      <span class="shortcut-hint"><kbd>Ctrl</kbd><span class="shortcut-plus">+</span><kbd>N</kbd></span>
      @if (networkVisible$ | async) {
        <span class="fade-config" title="HUD fade duration (minimized mode)">
          <button class="fade-btn" (click)="stepNetworkFade(-0.5)">-</button>
          <span class="fade-value">{{ (networkFadeMs$ | async)! / 1000 }}s</span>
          <button class="fade-btn" (click)="stepNetworkFade(0.5)">+</button>
        </span>
      }
    </div>

    <div class="toggle-row">
      <button class="face-toggle console" [class.active]="consoleVisible$ | async" (click)="toggleConsole()" title="Toggle Console panel">
        <span class="face-track">
          <span class="face-thumb">
            <mat-icon class="thumb-icon">terminal</mat-icon>
          </span>
        </span>
        <span class="face-label">Console</span>
      </button>
      <span class="shortcut-hint"><kbd>Ctrl</kbd><span class="shortcut-plus">+</span><kbd>D</kbd></span>
      @if (consoleVisible$ | async) {
        <span class="fade-config" title="HUD fade duration (minimized mode)">
          <button class="fade-btn" (click)="stepConsoleFade(-0.5)">-</button>
          <span class="fade-value">{{ (consoleFadeMs$ | async)! / 1000 }}s</span>
          <button class="fade-btn" (click)="stepConsoleFade(0.5)">+</button>
        </span>
      }
    </div>

    <div class="quick-links-row">
      <a class="quick-link-btn swagger" [href]="swaggerUrl" target="_blank" rel="noopener">
        <mat-icon>api</mat-icon>
        Swagger
      </a>
      @for (ql of quickLinks; track ql.link) {
        <a class="quick-link-btn" [href]="ql.link" target="_blank" rel="noopener">
          <mat-icon>open_in_new</mat-icon>
          {{ ql.name }}
        </a>
      }
    </div>
  </div>
  <div class="resize-handle" (mousedown)="startResize($event)"></div>
</div>
